<template>
  <b-container class="big-module-training">
    <b-row class="page-top">
      <b-col class="text-left">
        <span class="iconfont icon-tishi"></span>
        系统已为你自动定位不同题型的训练难度等级，请根据系统指引训练即可！
      </b-col>
      <b-col class="text-right" v-show="permission.indexOf('Plys.English.MiddleSchool.CanSkip') !== -1">
        <GlobalButtonParallelogram
          :sprintId="4"
          :tagId="2"
        ></GlobalButtonParallelogram>
      </b-col>
    </b-row>
    <b-row class="page-header">
      <b-col></b-col>
      <b-col>七年级</b-col>
      <b-col>八年级</b-col>
      <b-col>九年级</b-col>
      <b-col>预期时间</b-col>
      <b-col>实际时间</b-col>
    </b-row>
    <b-col
      :class="
        item.vocabularyTrainings.length < 1 ? 'page-text' : 'page-content'
      "
      v-for="(item, index) in bigModuleTrainings"
      :key="index"
    >
      <b-row class="title-table">
        <b-col sm="2" class="question-title">
          <div class="question-type">{{ item.sectionName }}</div>
        </b-col>
        <b-col
          v-show="item.vocabularyTrainings.length > 1 ? false : true"
          v-for="(items, c) in item.vocabularyTrainings"
          :key="c"
        >
          <b-row align-v="center">
            <b-col :v-if="items.seven != null">
              <!-- 七年级 -->
              <GlobalButtonDirectory
                
                :state="items.seven?items.seven.state:''"
                :starNum="items.seven?items.seven.star:''"
                @beginTest="
                  toTrainingQuestions(
                    item.sectionType,
                    items.questionSet,
                    items.seven,
                    item.sectionName,
                    items.trainingExamId
                  )
                "
              >
              </GlobalButtonDirectory>
            </b-col>
            <b-col :v-if="items.eighth != null">
              <!-- 八年级 -->
              <GlobalButtonDirectory
                :state="items.eighth?items.eighth.state:''"
                :starNum="items.eighth?items.eighth.star:''"
                @beginTest="
                  toTrainingQuestions(
                    item.sectionType,
                    items.questionSet,
                    items.eighth,
                    item.sectionName,
                    items.trainingExamId
                  )
                "
              >
              </GlobalButtonDirectory>
            </b-col>
            <b-col :v-if="items.nine != null">
              <!-- 九年级 -->
              <GlobalButtonDirectory
                   :state="items.nine?items.nine.state:''"
                :starNum="items.nine?items.nine.star:''"
                @beginTest="
                  toTrainingQuestions(
                    item.sectionType,
                    items.questionSet,
                    items.nine,
                    item.sectionName,
                    items.trainingExamId
                  )
                "
              >
              </GlobalButtonDirectory>
            </b-col>
            <b-col class="estimated-time"
              >{{ items.expectedMinutes }}分钟</b-col
            >
            <b-col class="actual-time">{{ items.actualMinutes }}分钟</b-col>
          </b-row>
        </b-col>
      </b-row>
      <div class="sub-content">
        <b-row
          v-show="item.vocabularyTrainings.length < 2 ? false : true"
          v-for="(items, c) in item.vocabularyTrainings"
          :key="c"
        >
          <b-col sm="2" class="read-title">
            <div>{{ items.trainingExamName }}</div>
          </b-col>
          <b-col :v-if="items.seven != null">
            <!-- 子组件七年级 -->
            <GlobalButtonDirectory
               :state="items.seven?items.seven.state:''"
                :starNum="items.seven?items.seven.star:''"
              @beginTest="
                toTrainingQuestions(
                  item.sectionType,
                  items.questionSet,
                  items.seven,
                  item.sectionName,
                  items.trainingExamId
                )
              "
            >
            </GlobalButtonDirectory>
          </b-col>
          <b-col :v-if="items.eighth != null">
            <!-- 子组件八年级 -->
            <GlobalButtonDirectory
              :state="items.eighth?items.eighth.state:''"
                :starNum="items.eighth?items.eighth.star:''"
              @beginTest="
                toTrainingQuestions(
                  item.sectionType,
                  items.questionSet,
                  items.eighth,
                  item.sectionName,
                  items.trainingExamId
                )
              "
            >
            </GlobalButtonDirectory>
          </b-col>
          <b-col :v-if="items.nine != null">
            <!-- 子组件九年级 -->
            <GlobalButtonDirectory
              :state="items.nine?items.nine.state:''"
                :starNum="items.nine?items.nine.star:''"
              @beginTest="
                toTrainingQuestions(
                  item.sectionType,
                  items.questionSet,
                  items.nine,
                  item.sectionName,
                  items.trainingExamId
                )
              "
            >
            </GlobalButtonDirectory>
          </b-col>
          <b-col class="estimated-time1">{{ items.expectedMinutes }}分钟</b-col>
          <b-col class="actual-time1">{{ items.actualMinutes }}分钟</b-col>
        </b-row>
      </div>
    </b-col>
  </b-container>
</template>

<script>
import GlobalButtonParallelogram from "@/components/global-button/global-button-parallelogram.vue";
import { getBigModuleTraining } from "../../api/english-big";
import GlobalButtonDirectory from "@/components/global-button/global-button-directory.vue";
import { mapMutations,mapState } from "vuex";
export default {
  data() {
    return {
      bigModuleTrainings: [],
      vocabularyTrainings: [],
    };
  },
  props: {
    sprintProgress: {
      default: 1,
    },
  },
  components: {
    GlobalButtonParallelogram,
    GlobalButtonDirectory,
  },
  computed: {
    ...mapState([
      "permission",
    ]),
  },
  mounted() {
    this.getSections();
  },
  methods: {
    ...mapMutations(["setTrainingData"]),
    getSections() {
      getBigModuleTraining({ examId: this.$route.query.examId }).then((res) => {
        console.log("靶向训练页", res);
        this.bigModuleTrainings = res.data.result.bigModuleTrainings;
      });
    },

    toTrainingQuestions(
      sectionType,
      questionSet,
      difficulty,
      sectionName,
      trainingExamId
    ) {
      let trainingData = {
        tagId: sectionType,
        setTagId: questionSet,
        difficultyTagId: difficulty.tagId,
        summaryId: difficulty.summaryId,
        trainingExamId: trainingExamId,
      };
      console.log("trainingData缓存", trainingData);
      this.setTrainingData(trainingData);
      this.$router.push({
        name: "BigModuleTrainingQuestions",
        query: {
          type: JSON.stringify(sectionType),
          // module: 2,
          name: sectionName,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.big-module-training {
  background: $bg-white;
  max-width: 1280px;
  min-height: 960px;
  padding: 20px 20px 50px;
}
.page-top {
  margin: 10px 0;
}
.text-left {
  color: $text-green;
  font-weight: bold;

}
.icon-suo1beifen {
  padding-right: 7px;
  font-size: 14px;
}
.page-header {
  border: 1px solid #e5e5e5;
  background-color: $bg-green;
  margin: 0 auto;
  width: 98%;
  color: #fff;
  padding: 10px 0;
  font-size: 16px;
}
.page-content {
  border-bottom: 1px solid #e5e5e5;
  margin: 0 auto;
  width: 98%;
  // padding: 10px 0;
}
.question-type {
  background: #ffc13b;
  width: 45%;
  line-height: 2.5;
  color: $text-white;
  border-radius: 5px;
}
.btn-suo {
  background: $bg-white;
  border: 1px solid #999;
  border-radius: 5px;
  color: #999;
  width: 50%;
  line-height: 1.5;
}
.estimated-time,
.estimated-time1,
.actual-time,
.actual-time1 {
  color: #999;
}
.read-title {
  text-align: left;
  padding-left: 45px;
}
.page-content .title-table {
  display: flex;
  align-items: center;
  justify-content: left;
  width: 100%;
  margin: 0 auto;
  padding: 10px 0;
}
.sub-content .row:nth-child(odd) {
  background: #eef9f4;
}
.sub-content .row {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  width: 100%;
  margin: 0;
}
.page-text {
  border: none;
  margin: 0 auto;
  width: 98%;
  padding: 10px 0;
  .title-table {
    width: 100%;
    margin: 0 auto;
  }
  .sub-content {
    padding-top: 1rem;
  }
}
.question-title {
  padding-left: 0;
}
</style>